module.exports = __webpack_public_path__ + "static/media/envelope-icon.b32bd644.svg";